import { useAlerts } from "../../../../hooks/generic/useAlerts";
import { lazy, Suspense } from "react";

const RectangleAlert = lazy(() =>
    import("../../../cards/alerts/RectangleAlert")
        .then(module => ({ default: module.RectangleAlert }))
);


export default function FloatingAlertsColumn () {
    const { alerts, removeAlert } = useAlerts();

    if (alerts.length === 0) return null;

    return (
        <div className="floating-column">
            <div></div>
            <Suspense fallback={null}>
                {alerts.map((alert, index) => (
                    <div key={index}>
                        <RectangleAlert 
                            message={alert.message} 
                            type={alert.type} 
                            removeAlert={() => removeAlert(index)} 
                        />
                    </div>
                ))}
            </Suspense>
        </div>
    );
}